'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('residential_uses', {
      url: '/account/density/residential_uses?jurisdiction&sta_recid',
      template: '<residential-uses></residential-uses>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null      // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/density/residential_uses/residential_uses.routes.js